export default __webpack_public_path__ + "static/media/SinkinSans-400Regular.b4374621.otf";